/**
 * @generated SignedSource<<eaab6ee410461a1a4692832be80df22d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InviteCardActionButton_Booking$data = {
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly slug: string;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useJoinableSpots_Booking">;
  readonly " $fragmentType": "InviteCardActionButton_Booking";
};
export type InviteCardActionButton_Booking$key = {
  readonly " $data"?: InviteCardActionButton_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"InviteCardActionButton_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InviteCardActionButton_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useJoinableSpots_Booking"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "b197256042f30ac47d2ff0af3add3af2";

export default node;
